"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasSiteSettingsTemplatesAccess = exports.getCanDisableJQuery = exports.getIsUngatedForOwnerDefaults = exports.getCanCreateBlogEmails = exports.getHasDomainPageAttachedStylesheetAccess = exports.getHasEmailTypeBlogAccess = exports.getHasEmailAccess = exports.getHasSocialAccess = exports.getHasListsAccess = exports.getHasMembershipTemplatesAccess = exports.getHasServiceKnowledgeAccess = exports.getHasExportMembershipLogsAccess = exports.getHasPipelineStageSelect = exports.getHasBuyNow = exports.getHasCustomProductProperties = exports.getHasMarketplaceAccess = exports.getHasTemplatesAccess = exports.getHasSiteSettingsCompanyNameAccess = exports.getHasServiceContentRestrictedWrite = exports.getHasMarketingContentMembershipAccess = exports.getisUngatedForEmailBlogOnlyAccess = exports.getHasEmailDragDropEditor = exports.hasTrackingAnonymizationAccess = exports.getAdAccountLimit = exports.getHasAdsRoiReporting = exports.getHasSitemapsAccess = exports.getHasCmsMultiLanguageScope = exports.getCanEditSitemaps = exports.getCanEditLanguageSettings = exports.getCanEditSiteSettings = exports.getCanEditBlogSettings = exports.getCurrencyLimit = exports.getHasThemesAccess = exports.hasContentSettingsScope = exports.hasWebsiteSettingsAccess = exports.hasEmailSettingsAccess = exports.getHasEmailWritePermissions = exports.getUngatedForQuotesApprovalV2 = exports.getUngatedForQuotesApprovalV1 = exports.getHasQuoteManageScope = exports.getHasQuoteAutomation = exports.getHasQuotesAccess = exports.getHasEditPrimaryLanguageAccess = exports.getHasMultiplePipelineSupport = exports.getHasMultiCurrencyWriteScope = exports.getHasMultiCurrencyReadScope = exports.getHasMultiCurrencyFeatureGate = exports.getHasCrmExportScope = exports.getHasBrandingFeatureScope = exports.getHasBrandingFeatureAccess = exports.getHasCustomerStarterFeatureAccess = exports.getHasSalesStarterFeatureAccess = exports.getIsMarketingBasicProOrEnterprise = exports.getIsEnterprise = exports.getHasSalesAcceleratorAddOn = exports.getPortalId = exports.getLimits = exports.getPortal = exports.getUserGates = exports.getUserScopes = exports.getUserEmail = exports.getUserId = exports.getUser = exports.getAuth = void 0;

var _reselect = require("reselect");

var _emailAuthSelectors = require("EmailData/selectors/emailAuthSelectors");

var _selectors = require("settings-ui-sdk/PortalSettings/selectors");

var getAuth = function getAuth(state) {
  return state.auth;
};

exports.getAuth = getAuth;
var getUser = (0, _reselect.createSelector)([getAuth], function (auth) {
  return auth.user;
});
exports.getUser = getUser;
var getUserId = (0, _reselect.createSelector)([getUser], function (user) {
  return user.user_id;
});
exports.getUserId = getUserId;
var getUserEmail = (0, _reselect.createSelector)([getUser], function (user) {
  return user.email;
});
exports.getUserEmail = getUserEmail;
var getUserScopes = (0, _reselect.createSelector)([getUser], function (user) {
  return user.scopes;
});
exports.getUserScopes = getUserScopes;
var getUserGates = (0, _reselect.createSelector)([getAuth], function (auth) {
  return auth.gates;
});
exports.getUserGates = getUserGates;
var getPortal = (0, _reselect.createSelector)([getAuth], function (auth) {
  return auth.portal;
});
exports.getPortal = getPortal;
var getLimits = (0, _reselect.createSelector)([getPortal], function (portal) {
  return portal.limits;
});
exports.getLimits = getLimits;
var getPortalId = (0, _reselect.createSelector)([getPortal], function (portal) {
  return portal.portal_id;
});
exports.getPortalId = getPortalId;
var getHasSalesAcceleratorAddOn = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['salesaccelerator-access', 'crm-access'].every(function (scope) {
    return scopes.indexOf(scope) > -1;
  });
});
exports.getHasSalesAcceleratorAddOn = getHasSalesAcceleratorAddOn;
var getIsEnterprise = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['multi-domain-publishing'].every(function (scope) {
    return scopes.indexOf(scope) > -1;
  });
});
exports.getIsEnterprise = getIsEnterprise;
var getIsMarketingBasicProOrEnterprise = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['content-access'].every(function (scope) {
    return scopes.indexOf(scope) > -1;
  });
});
exports.getIsMarketingBasicProOrEnterprise = getIsMarketingBasicProOrEnterprise;
var getHasSalesStarterFeatureAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['sales-hub-branding', 'meetings-link-customization'].some(function (scope) {
    return scopes.includes(scope);
  });
});
exports.getHasSalesStarterFeatureAccess = getHasSalesStarterFeatureAccess;
var getHasCustomerStarterFeatureAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['customer-hub-branding'].some(function (scope) {
    return scopes.includes(scope);
  });
});
exports.getHasCustomerStarterFeatureAccess = getHasCustomerStarterFeatureAccess;
var getHasBrandingFeatureAccess = (0, _reselect.createSelector)([getHasSalesStarterFeatureAccess, getHasCustomerStarterFeatureAccess], function (hasSalesStarter, hasCustomerStarter) {
  return hasSalesStarter || hasCustomerStarter;
});
exports.getHasBrandingFeatureAccess = getHasBrandingFeatureAccess;
var getHasBrandingFeatureScope = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['sales-settings-access'].every(function (scope) {
    return scopes.includes(scope);
  });
});
exports.getHasBrandingFeatureScope = getHasBrandingFeatureScope;
var getHasCrmExportScope = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['crm-export'].every(function (scope) {
    return scopes.includes(scope);
  });
});
exports.getHasCrmExportScope = getHasCrmExportScope;
var getHasMultiCurrencyFeatureGate = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return ['SalesEnterprise:EarlyAccess', 'MarketingEnterprise:EarlyAccess'].some(function (gate) {
    return gates.includes(gate);
  });
});
exports.getHasMultiCurrencyFeatureGate = getHasMultiCurrencyFeatureGate;
var getHasMultiCurrencyReadScope = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['multi-currency-read'].every(function (scope) {
    return scopes.includes(scope);
  });
});
exports.getHasMultiCurrencyReadScope = getHasMultiCurrencyReadScope;
var getHasMultiCurrencyWriteScope = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['multi-currency-write'].every(function (scope) {
    return scopes.includes(scope);
  });
});
exports.getHasMultiCurrencyWriteScope = getHasMultiCurrencyWriteScope;
var getHasMultiplePipelineSupport = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.some(function (gate) {
    return gate === 'Integrations:Salesforce:MultiplePipelineSupport' || gate === 'Integrations:Salesforce:RecordTypeSync';
  });
});
exports.getHasMultiplePipelineSupport = getHasMultiplePipelineSupport;
var getHasEditPrimaryLanguageAccess = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.includes('settings-ui-beta:edit-primary-language');
});
exports.getHasEditPrimaryLanguageAccess = getHasEditPrimaryLanguageAccess;
var getHasQuotesAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('quote-access');
});
exports.getHasQuotesAccess = getHasQuotesAccess;
var getHasQuoteAutomation = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['quote-automation'].every(function (scope) {
    return scopes.includes(scope);
  });
});
exports.getHasQuoteAutomation = getHasQuoteAutomation;
var getHasQuoteManageScope = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['quote-manage'].every(function (scope) {
    return scopes.includes(scope);
  });
});
exports.getHasQuoteManageScope = getHasQuoteManageScope;
var getUngatedForQuotesApprovalV1 = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.includes('Quotes:Automation');
});
exports.getUngatedForQuotesApprovalV1 = getUngatedForQuotesApprovalV1;
var getUngatedForQuotesApprovalV2 = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.includes('Quotes:ApprovalV2');
});
exports.getUngatedForQuotesApprovalV2 = getUngatedForQuotesApprovalV2;
var emailAuthSelectors = (0, _emailAuthSelectors.getEmailAuthSelectors)(getUserGates, getUserScopes, _selectors.getPortalSettingsResponse);
var getHasEmailWritePermissions = emailAuthSelectors.getHasEmailWritePermissions;
exports.getHasEmailWritePermissions = getHasEmailWritePermissions;
var hasEmailSettingsAccess = (0, _reselect.createSelector)([getUserScopes, getUserGates], function (scopes, gates) {
  return ['email-editor-access'].some(function (scope) {
    return scopes.includes(scope);
  }) && ['can-spam-settings-access', 'content-access'].some(function (scope) {
    return scopes.includes(scope);
  }) || ['double-opt-in-access'].every(function (scope) {
    return scopes.includes(scope);
  }) && ['Settings:DoubleOptInPanel'].every(function (gate) {
    return gates.includes(gate);
  });
});
exports.hasEmailSettingsAccess = hasEmailSettingsAccess;
var hasWebsiteSettingsAccess = (0, _reselect.createSelector)([getUserScopes, getUserGates], function (scopes) {
  return ['landingpages-access', 'site-pages-access'].some(function (scope) {
    return scopes.includes(scope);
  }) && ['marketing-settings-read', 'content-settings-access'].some(function (scope) {
    return scopes.includes(scope);
  });
});
exports.hasWebsiteSettingsAccess = hasWebsiteSettingsAccess;
var hasContentSettingsScope = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return ['content-settings-access'].every(function (scope) {
    return scopes.includes(scope);
  });
});
exports.hasContentSettingsScope = hasContentSettingsScope;
var getHasThemesAccess = (0, _reselect.createSelector)([getUserGates, getUserScopes], function (gates, scopes) {
  return gates.includes('CMS:Themes:Settings') && scopes.includes('themes-access');
});
exports.getHasThemesAccess = getHasThemesAccess;
var getCurrencyLimit = (0, _reselect.createSelector)([getLimits], function (limits) {
  return limits.currencies;
});
exports.getCurrencyLimit = getCurrencyLimit;
var getCanEditBlogSettings = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('blog-settings-write');
});
exports.getCanEditBlogSettings = getCanEditBlogSettings;
var getCanEditSiteSettings = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('site-settings-write');
});
exports.getCanEditSiteSettings = getCanEditSiteSettings;
var getCanEditLanguageSettings = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('language-settings-write');
});
exports.getCanEditLanguageSettings = getCanEditLanguageSettings;
var getCanEditSitemaps = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('sitemaps-write');
});
exports.getCanEditSitemaps = getCanEditSitemaps;
var getHasCmsMultiLanguageScope = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('cms-multi-language');
});
exports.getHasCmsMultiLanguageScope = getHasCmsMultiLanguageScope;
var getHasSitemapsAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('sitemaps-read');
});
exports.getHasSitemapsAccess = getHasSitemapsAccess;
var getHasAdsRoiReporting = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('ads-roi-reporting');
});
exports.getHasAdsRoiReporting = getHasAdsRoiReporting;
var getAdAccountLimit = (0, _reselect.createSelector)([getLimits], function (limits) {
  return limits['ads-accounts'];
});
exports.getAdAccountLimit = getAdAccountLimit;
var hasTrackingAnonymizationAccess = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.includes('Email:EmailServicesOpenTrackingAnonymizationEnabled');
});
exports.hasTrackingAnonymizationAccess = hasTrackingAnonymizationAccess;
var getHasEmailDragDropEditor = emailAuthSelectors.getCanCreateDragDropEmail;
exports.getHasEmailDragDropEditor = getHasEmailDragDropEditor;
var getisUngatedForEmailBlogOnlyAccess = emailAuthSelectors.getHasEmailBlogOnlyAccess;
exports.getisUngatedForEmailBlogOnlyAccess = getisUngatedForEmailBlogOnlyAccess;
var getHasMarketingContentMembershipAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('marketing-content-restricted-write');
});
exports.getHasMarketingContentMembershipAccess = getHasMarketingContentMembershipAccess;
var getHasServiceContentRestrictedWrite = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('service-content-restricted-write');
});
exports.getHasServiceContentRestrictedWrite = getHasServiceContentRestrictedWrite;
var getHasSiteSettingsCompanyNameAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('site-settings-company-name-access');
});
exports.getHasSiteSettingsCompanyNameAccess = getHasSiteSettingsCompanyNameAccess;
var getHasTemplatesAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('template-access');
});
exports.getHasTemplatesAccess = getHasTemplatesAccess;
var getHasMarketplaceAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('marketplace-access');
});
exports.getHasMarketplaceAccess = getHasMarketplaceAccess;
var getHasCustomProductProperties = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.includes('products:custom-properties');
});
exports.getHasCustomProductProperties = getHasCustomProductProperties;
var getHasBuyNow = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.includes('products:buy-now');
});
exports.getHasBuyNow = getHasBuyNow;
var getHasPipelineStageSelect = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.includes('products:buy-now-pipeline-stage-select');
});
exports.getHasPipelineStageSelect = getHasPipelineStageSelect;
var getHasExportMembershipLogsAccess = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.includes('memberships-log');
});
exports.getHasExportMembershipLogsAccess = getHasExportMembershipLogsAccess;
var getHasServiceKnowledgeAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('service-knowledge-access');
});
exports.getHasServiceKnowledgeAccess = getHasServiceKnowledgeAccess;
var getHasMembershipTemplatesAccess = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.includes('membership-templates');
});
exports.getHasMembershipTemplatesAccess = getHasMembershipTemplatesAccess;
var getHasListsAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('lists-access');
});
exports.getHasListsAccess = getHasListsAccess;
var getHasSocialAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('social-access');
});
exports.getHasSocialAccess = getHasSocialAccess;
var getHasEmailAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('email-access');
});
exports.getHasEmailAccess = getHasEmailAccess;
var getHasEmailTypeBlogAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('email-type-blog-access');
});
exports.getHasEmailTypeBlogAccess = getHasEmailTypeBlogAccess;
var getHasDomainPageAttachedStylesheetAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('domain-page-attached-stylesheet-access');
});
exports.getHasDomainPageAttachedStylesheetAccess = getHasDomainPageAttachedStylesheetAccess;
var getCanCreateBlogEmails = (0, _reselect.createSelector)([getHasEmailAccess, getHasEmailTypeBlogAccess, getisUngatedForEmailBlogOnlyAccess], function (hasEmailAccess, hasEmailTypeBlogAccess, isUngatedForBlogOnlyEmailAccess) {
  return hasEmailAccess || hasEmailTypeBlogAccess && isUngatedForBlogOnlyEmailAccess;
});
exports.getCanCreateBlogEmails = getCanCreateBlogEmails;
var getIsUngatedForOwnerDefaults = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.includes('settings-ui:owner-defaults');
});
exports.getIsUngatedForOwnerDefaults = getIsUngatedForOwnerDefaults;
var getCanDisableJQuery = (0, _reselect.createSelector)([getUserGates], function (gates) {
  return gates.includes('cos_no_jquery');
});
exports.getCanDisableJQuery = getCanDisableJQuery;
var getHasSiteSettingsTemplatesAccess = (0, _reselect.createSelector)([getUserScopes], function (scopes) {
  return scopes.includes('site-settings-templates-access');
});
exports.getHasSiteSettingsTemplatesAccess = getHasSiteSettingsTemplatesAccess;